/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'jiedian': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M510.9 64.7C264 64.7 63.7 264.9 63.7 511.9s200.2 447.2 447.2 447.2 447.2-200.2 447.2-447.2S757.9 64.7 510.9 64.7zm237.4 598.4c-10.9 14.6-29.2 15.3-40.8 1.6L525.2 454.3H498L315.6 664.7c-11.6 13.7-29.9 13-40.8-1.6-10.9-14.6-10.3-37.5 1.3-51.2L491.8 358c11.1-13.1 28.4-13.1 39.5 0L747 611.9c6.1 7.1 9.1 16.8 9.1 26.4 0 8.9-2.6 17.8-7.8 24.8z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/jiedian.js